import { MyApp } from 'app/MyApp';

// eslint-disable-next-line import/no-unassigned-import
import '@src/styles/global.scss';

export default MyApp;
